import React, { useState, useCallback } from 'react';
import './ContactForm.css';

function ContactForm() {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', help: '', message: '',
  });

  const handleChange = useCallback((e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }, []);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    alert('Thank you for your message! We will get back to you soon.');
    setForm({ name: '', email: '', phone: '', help: '', message: '' });
  }, []);

  return (
    <div className="contact-form-wrap reveal">
      <div className="contact-form-header">
        <h2 className="contact-form-title">Send us a message</h2>
        <p className="contact-form-subtitle">
          Need a callback? Drop your message and we'll get in touch.
        </p>
      </div>
      <form className="contact-form" onSubmit={handleSubmit}>
        <FormRow>
          <FormField label="Your Name" name="name" value={form.name} onChange={handleChange} />
          <FormField label="Email" name="email" type="email" value={form.email} onChange={handleChange} />
        </FormRow>
        <FormRow>
          <FormField label="Phone" name="phone" type="tel" value={form.phone} onChange={handleChange} />
          <FormField label="How can we help?" name="help" value={form.help} onChange={handleChange} />
        </FormRow>
        <TextArea label="Message" name="message" value={form.message} onChange={handleChange} />
        <button type="submit" className="contact-submit">
          Send Message
          <SendIcon />
        </button>
      </form>
    </div>
  );
}

function FormRow({ children }) {
  return <div className="contact-form-row">{children}</div>;
}

function FormField({ label, name, type = 'text', value, onChange }) {
  return (
    <div className="contact-field">
      <label className="contact-label">{label}</label>
      <input
        className="contact-input"
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required
      />
    </div>
  );
}

function TextArea({ label, name, value, onChange }) {
  return (
    <div className="contact-field">
      <label className="contact-label">{label}</label>
      <textarea
        className="contact-input contact-textarea"
        name={name}
        value={value}
        onChange={onChange}
        rows="5"
        required
      />
    </div>
  );
}

function SendIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22,2 15,22 11,13 2,9" />
    </svg>
  );
}

export default ContactForm;
